<template>
    <div class="chapter-field">
        <div class="flex-row-between">
            <div>{{scope.row[scope.column.property]}}</div>
            <div @click="editHandle"><i class="el-icon-edit color-green"></i></div>
        </div>
        <el-dialog title="排序值修改" :visible.sync="dialogFormVisible">
            <el-form>
                <el-col :span="24">
                    <span class="span_sty">将章节<span class="span_cont">{{this.scope.row.chapter_sn + '(' + this.scope.row.chapter_name + ')'}}</span>调整到</span>
                </el-col>
                <el-col :span="24">
                    <el-form-item>
                        <el-select v-model="checkChapter" placeholder="请选择活动区域">
                            <el-option
                            v-for="item in chapterList"
                            :key="item.chapter_id"
                            :label="item.chapter_sn + ' ' + item.chapter_name"
                            :value="item.chapter_id"></el-option>
                        </el-select>
                        <span class="span_sty">的后面</span>
                    </el-form-item>
                </el-col>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="editChapterSort">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
/*
 * @Author: daipeng
 * @Date: 2018-09-21 13:33:56
 * @LastEditors: OBKoro1
 * @LastEditTime: 2018-10-18 09:13:59
 * @Description: 章节列表-行内编辑
 * @Company: 成都二次元动漫
 */

export default {
    props: {
        scope: Object,
        sort: {}
    },
    data() {
        return {
            cloneRowData: null,
            dialogFormVisible: false,
            chapterList: [],
            checkChapter: '',
            animation_id: '',
            chapter_id: ''
        };
    },
    methods: {
        // 点击编辑
        editHandle() {
            this.dialogFormVisible = true;
            this.cloneRowData = this.$utils.cloneDeep(this.scope.row);
            const { animation_id, chapter_id } = this.scope.row;
            this.animation_id = animation_id;
            this.chapter_id = chapter_id;
            this.getChapterList();
        },

        // 确认修改
        editChapterSort() {
            this.$api('editAnChapterOrder', { animation_id: this.animation_id, curr_chapter_id: this.chapter_id, target_chapter_id: this.checkChapter }).then(res => {
                this.$message.success(`修改成功！`);
                this.dialogFormVisible = false;
                this.$emit('getTableList');
            });
        },

        // 获取章节列表
        getChapterList() {
            this.$api('getAnComicChapterList', { animation_id: this.animation_id, pageSize: 9999, sort: this.sort }).then(res => {
                this.chapterList = res.data.chapter.rows;
                this.chapterList.some(item => {
                    if (item.chapter_id === this.chapter_id) {
                        this.checkChapter = item.chapter_id;
                    }
                    return item.chapter_id === this.chapter_id;
                });
            });
        }
    }
};
</script>

<style lang="scss" scoped>
    .el-icon-edit{
        cursor: pointer;
    }
    .span_sty{
        display: inline-block;
        font-size: 16px;
        margin-bottom: 15px;
        .span_cont{
            display: inline-block;
            color: #409EFF;
            margin: 0 10px;
            font-size: 16px;
        }
    }
</style>
